import { Popover, Typography, Alert } from '@mui/material'
import { CvsAvatar, Paper } from '@components'
import { User } from '@global/types'
import * as css from './commentPopover/styles'
import { t } from '@lingui/core/macro'

interface Props {
  anchorEl: Element | (() => Element) | null | undefined
  open: boolean
  rejectionComments: [
    {
      message: string
      user: User
    },
  ]
  handlePopoverClose: (event: object) => void
}

export const RejectionCommentPopover = ({
  anchorEl,
  open,
  rejectionComments,
  handlePopoverClose,
}: Props) => {
  const classes = css.usePopoverStyles()
  const comment = rejectionComments.length > 0 ? rejectionComments[0] : { message: '', user: null }

  return (
    <Popover
      open={open}
      className={classes.popover}
      classes={{
        paper: classes.popoverContent,
      }}
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      onClose={handlePopoverClose}
      disableRestoreFocus
    >
      <Paper css={css.paper}>
        <Alert variant="outlined" severity="error">
          Value rejected during approval
        </Alert>
        <css.CommentContainer>
          <CvsAvatar user={comment.user} />
          <css.Message>
            <Typography variant="body1" css={[css.bold, css.smallerFont]}>
              {`${comment.user?.name} `}
              {t`left a comment...`}
            </Typography>
            <Typography variant="body1" css={css.smallerFont}>
              {comment.message}
            </Typography>
          </css.Message>
        </css.CommentContainer>
      </Paper>
    </Popover>
  )
}
